const AGENDA_MENU_ITEMS = [
  { key: 'calendar', to: '/agenda', labelKey: 'appointments.menu.calendar', fullLabelKey: 'mainDrawer.listItems.agenda', access: 'canAccessAgenda' },
  { key: 'reports', to: '/agenda/relatorios', labelKey: 'appointments.buttons.reports', fullLabelKey: 'appointments.reports.title', access: 'canManageAgenda' },
  { key: 'settings', to: '/agenda/configuracoes', labelKey: 'appointments.buttons.settings', fullLabelKey: 'appointments.settings.title', access: 'canManageAgenda' },
]

export const getAgendaMenuItems = permissions => AGENDA_MENU_ITEMS.filter(item => Boolean(permissions?.[item.access]))

export const isAgendaPath = path => path === '/agenda' || String(path || '').startsWith('/agenda/')

export const isAgendaMenuItemActive = (item, path) => {
  const currentPath = String(path || '').replace(/\/+$/, '') || '/'

  if (item.to === '/agenda') {
    return currentPath === '/agenda'
  }

  return currentPath === item.to || currentPath.startsWith(`${item.to}/`)
}
